import React, { useEffect, useState } from "react";
import GraphicCard from "../../../app/components/GraphicCard";
import Toast from "../../../app/components/Toast";
import FormServiceDelete from "../../../forms/FormPanel/DeleteGraphic";
import { usePageTitle } from '../../../contexts/PageTitleContext';

const Dashboard = () => {
    const { setTitle } = usePageTitle();
  
    useEffect(() => {
      setTitle('Dashboard');
    }, [setTitle]);
  
  const [starredGraphics, setStarredGraphics] = useState([]);
  const [toastMessage, setToastMessage] = useState(null);
  const [graphicToDelete, setGraphicToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("starredGraphics") || "[]");
    setStarredGraphics(stored);
  }, []);

  const showToast = (message, type = "success") => {
    setToastMessage({ message, type });
  };

  const handleToggleStar = (graphic) => {
    const updated = starredGraphics.filter((g) => g.id !== graphic.id);
    localStorage.setItem("starredGraphics", JSON.stringify(updated));
    setStarredGraphics(updated);
    showToast(`Gráfico "${graphic.titulo}" removido dos favoritos.`, "info");
  };

  const handleOpenDeleteGraphic = (graphic) => {
    setGraphicToDelete(graphic);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    const updated = starredGraphics.filter((g) => g.titulo !== graphicToDelete.titulo);
    localStorage.setItem("starredGraphics", JSON.stringify(updated));
    setStarredGraphics(updated);
    showToast(`Gráfico "${graphicToDelete.titulo}" excluído com sucesso!`);
    setIsDeleteModalOpen(false);
    setGraphicToDelete(null);
  };

  return (
    <div>
      {starredGraphics.length > 0 ? (
        <div className="flex flex-wrap gap-6">
          {starredGraphics.map((graphic, index) => (
            <GraphicCard
              key={index}
              graphic={graphic}
              isStarred={true}
              resizable={true}
              width={500}
              height={350}
              onToggleStar={() => handleToggleStar(graphic)}
              onDelete={() => handleOpenDeleteGraphic(graphic)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-500 text-sm pt-24">
          <span className="font-medium">Nenhum gráfico favoritado no momento.</span> <br />
          Vá até "Painéis" e favorite um gráfico.
        </div>
      )}


      {toastMessage && (
        <Toast
          message={toastMessage.message}
          type={toastMessage.type}
          onClose={() => setToastMessage(null)}
        />
      )}

      <FormServiceDelete
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        item={graphicToDelete}
      />
    </div>
  );
};

export default Dashboard;
